import React, { useState } from "react";
import "./Login.css";

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const logoUrl = `${process.env.PUBLIC_URL || ""}/Logo.png`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      await onLogin(form.username.trim(), form.password);
    } catch (err) {
      console.error(err);
      setError(err.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-shell">
        <section className="login-showcase" aria-label="ARF Seafoods operations">
          <div className="login-brand-lockup">
            <div className="login-logo-frame">
              <img src={logoUrl} alt="" className="login-logo" />
            </div>
            <div>
              <div className="login-brand-title">ARF Seafoods</div>
              <div className="login-brand-subtitle">Operations &amp; billing portal</div>
            </div>
          </div>

          <div className="login-showcase-content">
            <div className="login-eyebrow login-hero-eyebrow">SEAFOOD BUSINESS MANAGEMENT</div>
            <h1>
              Fresh stock.<br />
              Faster billing.<br />
              <em>Better business.</em>
            </h1>
            <p>
              Manage stock, sales and payments through one clear workspace built for ARF Seafoods.
            </p>
          </div>

          <div className="login-showcase-footer">Fresh from nature. Delivered with care.</div>
        </section>

        <section className="login-panel" aria-labelledby="login-heading">
          <div className="login-card-content">
            <div className="login-form-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><rect x="5" y="10" width="14" height="11" rx="3"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v2"/></svg>
            </div>
            <div className="login-card-header">
              <div className="login-eyebrow">SECURE SIGN IN</div>
              <h2 id="login-heading">Welcome back</h2>
              <p>Enter your account details to open the operations dashboard.</p>
            </div>

            {error ? <div id="login-error" className="login-alert" role="alert">{error}</div> : null}

            <form className="login-form" onSubmit={handleSubmit} aria-busy={loading} aria-describedby={error ? "login-error" : undefined}>
              <div className="login-field">
                <label htmlFor="login-username">Username</label>
                <div className="login-input-shell">
                  <span className="login-input-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><circle cx="12" cy="8" r="4"/><path d="M4.5 21a7.5 7.5 0 0 1 15 0"/></svg>
                  </span>
                  <input id="login-username" className="login-input" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} placeholder="Enter your username" required disabled={loading} />
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="login-password">Password</label>
                <div className="login-input-shell login-password-row">
                  <span className="login-input-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><rect x="4" y="10" width="16" height="11" rx="3"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
                  </span>
                  <input id="login-password" className="login-input" type={showPassword ? "text" : "password"} autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Enter your password" required disabled={loading} />
                  <button type="button" className="login-toggle-btn" onClick={() => setShowPassword((value) => !value)} aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword}>{showPassword ? "Hide" : "Show"}</button>
                </div>
              </div>

              <button type="submit" className="login-submit-btn" disabled={loading}>
                <span>{loading ? "Signing in..." : "Sign in"}</span>
                <span className="login-submit-arrow" aria-hidden="true">{loading ? "..." : "\u2192"}</span>
              </button>
            </form>

            <div className="login-footer-note">
              Need help? <strong>Contact your administrator.</strong>
            </div>
          </div>

          <footer className="login-panel-footer">&copy; {new Date().getFullYear()} ARF Seafoods</footer>
        </section>
      </div>
    </main>
  );
}
